import Branch from './Branch.vue'
import MenuItem from "../../../core/components/menu/MenuItem";
import i18n from '../../../shared/i18n'

let routes = [
  {
    path: 'branches',
    name: 'branches',
    component: Branch,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: 'branches/:branch_uuid/item-locations/:item_location_uuid',
    name: 'branch-item-locations',
    component: Branch,
    meta: {
      requiresAuth: true
    },
    redirect: to => {
      return {
        name: 'branches',
        params: {
          item_location_uuid: to.params.item_location_uuid,
          branch_uuid: to.params.branch_uuid,
        }
      };
    }
  }
];

export default {
  menuItem: new MenuItem('/branches', i18n.t('Branches'), 40, 'building'),
  routes: routes
}

